import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useNavigate } from 'react-router-dom';

export default function UpdatePassword() {
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isTestUser, setIsTestUser] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        // Definiere Testuser, z. B. mit bestimmter Domain oder E-Mail
        const testEmails = ['testhuber@gmail.com', 'ronaldm@test.at', 'romatmontagen@gmx.at', 'silviad@test.at'];
        if (testEmails.includes(user.email)) {
          setIsTestUser(true);
        }
      }
    };
    checkUser();
  }, []);

  const handlePasswordUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setMessage('❌ Fehler beim Zurücksetzen: ' + error.message);
    } else {
      setMessage('✅ Passwort erfolgreich geändert!');
      if (isTestUser) {
        // Testuser bleibt eingeloggt, optional Redirect
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      } else {
        // Normale User werden ausgeloggt und zur Login-Seite weitergeleitet
        await supabase.auth.signOut();
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-orange-50 px-4">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-md text-center">
        <h1 className="text-2xl font-bold mb-4 text-orange-600">🔐 Neues Passwort setzen</h1>
        <p className="mb-6 text-gray-700">
          Bitte gib dein neues Passwort ein und bestätige, um fortzufahren.
        </p>
        <form onSubmit={handlePasswordUpdate} className="space-y-4">
          <input
            type="password"
            placeholder="Neues Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded"
            required
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-orange-500 text-white py-2 rounded hover:bg-orange-600 transition"
          >
            {loading ? 'Speichern...' : 'Passwort speichern'}
          </button>
        </form>
        {message && <p className="mt-4 text-sm text-gray-800">{message}</p>}
      </div>
    </div>
  );
}
